import { CheckCircle, XCircle, AlertTriangle, Loader2 } from 'lucide-react'

interface AttestationReviewActionsProps {
  onApprove: () => void
  onReject: () => void
  onRequestChanges: () => void
  isLoading?: boolean
}

export default function AttestationReviewActions({
  onApprove,
  onReject,
  onRequestChanges,
  isLoading = false,
}: AttestationReviewActionsProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Review Actions</h2>
      <div className="flex flex-col sm:flex-row gap-3">
        {/* Approve Button */}
        <button
          onClick={onApprove}
          disabled={isLoading}
          className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 text-white bg-green-600 rounded-xl hover:bg-green-700 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <CheckCircle className="w-5 h-5" />
          )}
          Approve Attestation
        </button>

        {/* Request Changes Button */}
        <button
          onClick={onRequestChanges}
          disabled={isLoading}
          className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 text-amber-700 bg-amber-50 border border-amber-200 rounded-xl hover:bg-amber-100 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <AlertTriangle className="w-5 h-5" />
          )}
          Request Changes
        </button>

        {/* Reject Button */}
        <button
          onClick={onReject}
          disabled={isLoading}
          className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 text-red-700 bg-red-50 border border-red-200 rounded-xl hover:bg-red-100 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <XCircle className="w-5 h-5" />
          )}
          Reject
        </button>
      </div>

      {/* Help Text */}
      <div className="mt-4 text-sm text-gray-500 space-y-1">
        <p><strong>Approve:</strong> Activates the attestation and enables regulated features.</p>
        <p><strong>Request Changes:</strong> Notifies tenant to update their submission.</p>
        <p><strong>Reject:</strong> Permanently rejects - tenant must submit a new attestation.</p>
      </div>
    </div>
  )
}
